import { useMutation } from "react-query";

import type { UpdateUserSubscriptionPayload } from "@jti/rest-api-types";

import { MUTATION_KEYS } from "../../../constants/queryKeys";
import { SubscriptionsApi } from "../../../services";

type UpdateUserSubscriptionVariables = {
  uuid: string;
  data: UpdateUserSubscriptionPayload;
};

type UseUpdateUserSubscriptionOptions = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useUpdateUserSubscription = ({
  onSuccess,
  onError,
}: UseUpdateUserSubscriptionOptions | undefined = {}) => {
  const subscriptionsApiClient = SubscriptionsApi.init();

  return useMutation(MUTATION_KEYS.updateUserSubscription, {
    mutationFn: ({ uuid, data }: UpdateUserSubscriptionVariables) =>
      subscriptionsApiClient.updateSubscription(uuid, data),
    onSuccess,
    onError,
  });
};
